import React, { Component } from 'react';
import scrollToComponent from 'react-scroll-to-component';

export class Scroller extends Component {
  scroll() {
    if (!this.props.scrollTo) {
      return;
    }
    scrollToComponent(this.scrollElement, {
      align: 'top',
      duration: 250,
      ease: 'inOutQuad',
    });
  }

  componentDidMount() {
    // on initial load wait a bit before scrolling user down to appropriate section
    setTimeout(() => this.scroll(), 1000);
  }

  componentDidUpdate() {
    this.scroll();
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { render: innerRender, scrollTo: $dontcare, ...props } = this.props;

    return (
      <section {...props}>
        {innerRender(scrollElement => (this.scrollElement = scrollElement))}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Scroller.js